export enum StepCybermetrieEnum {
  ETAPE_TYPE_PROPRIETE,
  AIGUILLEUR_RESIDENCE_PRINCIPALE,
  AIGUILLEUR_MULTIPROPRIETAIRE,
  AIGUILLEUR_SALARIE,
  AIGUILLEUR_CITOYENNETE,
  ETAPE_COEMPRUNTEUR,
  ETAPE_ACHAT_A_DEUX,
  ETAPE_MEME_COEMPRUNTEUR,
  ETAPE_CONSENTEMENT,
  ETAPE_REVENU_BRUT,
  ETAPE_HYPOTHEQUE,
  ETAPE_PRIX_PROPRIETE,
  ETAPE_REVENU_LOCATIF,
  ETAPE_MISE_DE_FONDS,
  ETAPE_COORDONNEES,
  ETAPE_VALIDATION,
  ETAPE_CONTRE_OFFRE,
  ETAPE_CHOIX_TAUX,
  ETAPE_EN_ATTENTE_COEMPRUNTEUR, // CO1
  ETAPE_CODE_INVITATION, // CO2
  ETAPE_ACCEPTER_PROJET // CO2
}
